import { useEffect } from 'react';

/**
 * Full-screen "you achieved something!" toast. Auto-dismisses after 4s.
 */
export default function CelebrationOverlay({ message, onFinished }) {
  useEffect(() => {
    const timer = setTimeout(onFinished, 4000);
    return () => clearTimeout(timer);
  }, [onFinished]);

  return (
    <div className="celebration-toast">
      <div style={{ fontSize: '1.5rem' }}>🏆</div>
      <div>{message}</div>
    </div>
  );
}
